import { DecimalPipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { AppLocalizationService } from '../../../services/AppLocalizationService';
/**
 * Returns a number formatted ***IN RD LOCALE***
 */
@Pipe({ name: 'rdLocalizedNumber' })
export class RdLocalizedNumberPipe implements PipeTransform {
  /**
   * Constructor
   * @param decimalPipe
   * @param ais
   */
  constructor(private decimalPipe: DecimalPipe, private appLocalization: AppLocalizationService) { }

  /**
   * Returns a number formatted ***IN RD LOCALE***
   * @param input Number input
   * @param numFrac Amount of decimal places
   * @param hide0 Hide if 0
   * @param unit Unit suffix
   * @param prefix Prefix
   * @param valueIfUndefinedOrZero ISNULL value if undefined or 0/null
   */
  transform(input: any, numFrac: number, hide0: boolean, unit: string, prefix: string, valueIfUndefinedOrZero: any): string {
    if (input == 0 && hide0) {
      return null;
    }

    if (typeof (valueIfUndefinedOrZero) !== 'undefined' && !input) {
      return valueIfUndefinedOrZero;
    }

    if (input == null || isNaN(parseFloat(input))) {
      if (hide0) {
        return null;
      }

      input = 0;
    }

    const dictionaryConfig = this.appLocalization.getReportDesignerDictionaryConfig();

    /**************************************************************************************************
     * we will pick locale based on decimalSeparator of dictionary config
     * otherwise we should import all locales (from @angular/common/locales)
     * that we support in app
     * for example take alook in app.module.ts where few locales are registred using registerLocaleData
     **************************************************************************************************/
    const locale: string = dictionaryConfig.decimalSeparator === '.' ? 'en-US' : 'de-DE';

    const format = numFrac !== undefined ? `1.${numFrac}-${numFrac}` : '1.0-10';

    let formattedValue = this.decimalPipe.transform(input, format, locale);

    if (prefix) {
      formattedValue = `${prefix} ${formattedValue}`;
    }

    if (unit) {
      formattedValue = `${formattedValue} ${unit}`;
    }

    return formattedValue;
  }
}
